import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { prepareLangKey } from 'libs/common';
import { Content } from './tarifficator-selector.styled';

export const TarifficatorSelector = (props) => {
  const { onChange, value, items } = props;
  const { t, i18n } = useTranslation();

  /**
   * get tarifficator title
   */
  const getTitle = useCallback(
    (tarifficator) => {
      // check path
      let test = 'tarifficators.' + prepareLangKey(tarifficator.path);
      if (i18n.exists(test)) {
        return t(test);
      }

      // check template
      test = 'tarifficatorTpls.' + prepareLangKey(tarifficator.template);
      if (i18n.exists(test)) {
        return t(test) + ' (' + tarifficator.path + ')';
      }
      return tarifficator.path;
    },
    [t]
  );

  const itemsEl = items.map((el, idx) => {
    const title = getTitle(el);
    return (
      <option value={el.path} key={idx}>
        {title}
      </option>
    );
  });

  /**
   * change
   * @param {*} event 
   */
  const change = (event) => {
    onChange(event.target.value);
  };

  return (
    <Content>
      <select onChange={change} value={value.path}>
        {itemsEl}
      </select>
    </Content>
  );
};
